<template>
  <div>
    <div v-if="errorHandling" class="col-12 red">
      {{ errorHandling }}
    </div>
    <div class="col-12 p0 py2 my1 break-word">
      <div class="m0 h5 bold caps">{{ user.firstname }}, choisissez votre produit</div>
    </div>
    <div v-if="firstSession" class="col-12 p0 py2 my1 break-word">
      <div class="m0 h6 bold caps">{{ firstSession.nomActivite }}</div>
      <div class="m0 h6 bold">{{ frenchTime(firstSession.timestampDebutCreneau, "EEEE dd MMMM") }} / {{ frenchTime(firstSession.timestampDebutCreneau, "HH'h'mm") }} - {{ frenchTime(addSeconds(firstSession.timestampFinCreneau, 1), "HH'h'mm") }}</div>
    </div>
    <div class="col-12 white-bg p2">
      <div
        v-if="offers.length === 0"
        class="col-12 card-top border"
      >
        <div class="flex flex-wrap">
          <div class="col-2 xs-hide flex justify-start items-center">
            <div class="user-icon red-bg">
              <i
                class="
                  icon
                  flex
                  justify-center
                  white
                  mx-auto
                  line-height-1
                  relative
                  h1
                  i-user
                  mt2
                "
              ></i>
            </div>
          </div>
          <div class="col-10 sm-col-8 flex justify-center">
            <h4 class="h4 mt1 mb0 center flex items-center">
              Il n'y a plus de produits à ajouter
            </h4>
          </div>
        </div>
      </div>

      <div
        v-for="(o, index) in offers"
        :key="o.uuid"
        :class="[{'mb2': index < offers.length-1}]"
      >
        <OfferItem :offer="o" :contact="user" />
      </div>
    </div>
    <div class="flex flex-wrap">
      <div class="col-12 py3 flex flex-wrap justify-end items-center">
        <Button
          class="col-3 sm-col-12 p1"
          :action="handleBack"
          :text="'Retour'"
          color="grey-bg"
        />
        <Button
          v-if="!loading"
          class="col-4 sm-col-12 p1"
          :disabled="!canAdvance"
          :action="confirmOffer"
          text="Suivant"
        />
        <Button
          v-else
          class="col-4 sm-col-12 p1"
          :disabled="true"
          icon="icon icon-loader"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { addSeconds } from 'date-fns';
import Button from '../../components/elements/Button';
import OfferItem from '../../components/offers/OfferItem';
import { changeToPage, injectCurrentParticipant } from '@/utils/logics';
import { backToAlpha, frenchTime } from '@/utils/utils';

export default {
  components: { Button, OfferItem },
  data () {
    return {
      contacts: this.$store.state.user.contacts,
      loading: false,
      currentParticipant: this.$store.state.currentParticipant
    };
  },
  computed: {
    user () {
      return this.$store.state.user;
    },
    workspace () {
      return this.$store.state.siteInfo.workspace;
    },
    offers () {
      return this.$store.state.product.dynamo_offers || [];
    },
    firstSession () {
      return this.$store.state.sessions?.items[0];
    },
    errorHandling () {
      return this.$store.state.productError;
    },
    canAdvance () {
      return this.$store.state.cartItem.participants.length && this.$store.state.cartItem.participants.every(participant => !!participant.tariff);
    }
  },
  async created () {
    const { cartItem, currentParticipant } = this.$store.state;
    if (!cartItem) {
      this.$store.commit('setCartItem', {
        workspace: this.workspace,
        participants: [this.user]
      });
    }
    if (!currentParticipant) {
      this.$store.commit('setCurrentParticipant', this.user);
    }
  },
  methods: {
    backToAlpha,
    changeToPage,
    frenchTime,
    addSeconds,
    handleBack () {
      this.backToAlpha();
    },
    async confirmOptions () {
      this.loading = true;
    },
    async confirmOffer () {
      this.loading = true;
      const { currentParticipant } = this.$store.state;
      const { options } = this.$store.state.offerInfo;
      this.$store.commit('setAvailableOptions', options);

      if (!options.length) {
        currentParticipant.options = options;
        await injectCurrentParticipant({ ...currentParticipant, quantity: 1 });
      } else {
        this.changeToPage('EscapeOptions');
      }
      this.loading = false;
    }
  }
};
</script>
